import React from 'react';
import { checkoutReservation, stayOverActions } from './controler';
import LoadingButton from '@components/buttons/loadingButton';
// import { condoStatusCheck } from '@pages/newReservations/utils';
import { CheckoutOptionsProps } from './interfaces';
import { translate } from '@data/translations';
import InlineModal from '@components/modalInline';
import {
    RoomInfoEditModel,
    ReservationStatus,
    // InvoiceModelWithInvoiceItems,
    ReservationModelWithModelsIncluded,
} from '@common/modelDefinition';
import { SRCClearRoomCodes } from '@components/SRCClearRoomCodes';
import { InvoicedStatusEnum } from '@common/enums';

export const CheckoutButton = (props: CheckoutOptionsProps) => {
    const {
        reservation,
        location,
        reservationId,
        groupUuid,
        roomInfoMap,
        // invoice,
        // accommodationInvoice,
        // posTerminalInvoices,
        // minibarInvoices,
        // genuineInvoices,
    } = props;

    const [checkOut, setCheckout] = React.useState<boolean>(false);

    if (!reservation) {
        return null;
    }

    const roomInfo: RoomInfoEditModel | null = reservation && roomInfoMap ? roomInfoMap[reservation.roomInfoId] : null;

    // const { pendingInvoice } = invoice;

    // const activePosTerminalInvoices = posTerminalInvoices.filter(
    //     (i: InvoiceModelWithInvoiceItems) => i.connectedInvoiceProcessed !== 1
    // );
    // const activeMinibarInvoices = minibarInvoices.filter(
    //     (i: InvoiceModelWithInvoiceItems) => i.connectedInvoiceProcessed !== 1
    // );

    // const { isCondoReservation } = condoStatusCheck(reservation);

    // const accomodationInvoiceIssued = genuineInvoices.filter((i) => {
    //     const { InvoiceItems } = i;
    //     const accommodationInvoiceItems = InvoiceItems.filter((it) => it.type === 'accommodation');
    //     if (accommodationInvoiceItems.length > 0) {
    //         return i;
    //     } else {
    //         return null;
    //     }
    // });

    return (
        <div>
            <InlineModal show={checkOut} header={translate('Checkout options')} width="md" setShow={setCheckout}>
                {checkOut ? (
                    <CheckoutTimeOptions
                        setCheckout={setCheckout}
                        reservation={reservation}
                        reservationId={reservationId}
                        groupUuid={groupUuid}
                        location={location}
                    />
                ) : null}
            </InlineModal>
            {reservation.statusEnum === ReservationStatus.checkedIn ? (
                <LoadingButton
                    onClick={() => {
                        setCheckout(true);
                    }}
                    className="button-primary no-print"
                >
                    {reservation?.invoicedStatus === InvoicedStatusEnum.notPaid
                        ? translate('Checkout (no invoice)')
                        : translate('Checkout')}
                </LoadingButton>
            ) : roomInfo && reservation.statusEnum === ReservationStatus.closed ? (
                <SRCClearRoomCodes roomInfo={roomInfo} className={'mr-16p'} />
            ) : null}
        </div>
    );
};

const StayoverOverlapSelection = (props: CheckoutOptionsProps) => {
    const { stayoverOverlap, reservation } = props;
    const { overlapReservations } = stayoverOverlap;

    if (overlapReservations.length === 0 || !reservation) {
        return null;
    }

    let optionCheck: number | null =
        stayoverOverlap.overlapReservations.length > 0 && stayoverOverlap.type === 'checkOut'
            ? stayoverOverlap.option
            : null;

    const arrayOfActions = [
        translate('Check out now and move the next reservation.'),
        translate('Check out before the start of the next reservation.'),
        translate('Check out at initial checkout.'),
        translate('Set reservations manually.'),
    ];

    let listOfActions = [];
    for (let i = 0; i < arrayOfActions.length; i++) {
        listOfActions.push(
            <li
                key={i + 1}
                onClick={() => {
                    stayOverActions(stayoverOverlap.overlapReservations, i + 1, 'checkOut');
                }}
                className="list-group-item p-2 pointer"
            >
                {arrayOfActions[i]}
                {optionCheck === i + 1 ? (
                    <i className="fa fa-2x fa-check-square-o pull-right mr-2" />
                ) : (
                    <i className="fa fa-2x fa-square-o pull-right mr-2" />
                )}
            </li>
        );
    }

    if (
        stayoverOverlap.type === 'checkOut' &&
        reservation.statusEnum === ReservationStatus.checkedIn &&
        stayoverOverlap.option !== 4
    ) {
        return (
            <div className="row mb-2">
                <div className="col-md-12">
                    <ul className="list-group mt-2 text-left">{listOfActions}</ul>
                </div>
            </div>
        );
    } else {
        return null;
    }
};

interface CheckoutTimeOptionsProps {
    setCheckout: Function;
    reservation: ReservationModelWithModelsIncluded;
    reservationId: number | null;
    groupUuid: string | null;
    location: any;
}
export const CheckoutTimeOptions = (props: CheckoutTimeOptionsProps) => {
    const { setCheckout, reservation, reservationId, groupUuid, location } = props;
    return (
        <div className="container-fluid">
            {reservation?.invoicedStatus === InvoicedStatusEnum.notPaid ||
            reservation?.invoicedStatus === InvoicedStatusEnum['Partial payment'] ? (
                <div className="color-error font-20p flex-center-center mb-20p">
                    {reservation?.invoicedStatus === InvoicedStatusEnum.notPaid
                        ? translate('Invoice is not paid!')
                        : reservation?.invoicedStatus === InvoicedStatusEnum['Partial payment']
                        ? translate('Invoice is partial payed!')
                        : null}
                </div>
            ) : null}
            {reservation?.invoicedStatus !== InvoicedStatusEnum['fully paid'] ? (
                <div className="color-error font-20p flex-center-center mb-20p">
                    {translate('You will not be able to change the invoice later.')}
                </div>
            ) : null}
            <br />
            <div className="text-center mb-16p">{translate('Please select a check-out time')}</div>

            <div className="text-center flex-center-between ">
                <button
                    disabled={reservation.providerReservation ? true : false}
                    onClick={async () => {
                        await checkoutReservation(reservation, reservationId, groupUuid, location, true);
                        setCheckout(false);
                    }}
                    className="button-primary m-1"
                >
                    {translate('Apply current time')}
                </button>
                <button
                    onClick={async () => {
                        await checkoutReservation(reservation, reservationId, groupUuid, location, false);
                        setCheckout(false);
                    }}
                    className="button-info m-1"
                >
                    {translate('Apply the planned time')}
                </button>

                <button
                    onClick={() => {
                        setCheckout(false);
                    }}
                    className="button-light m-1"
                >
                    {translate('Cancel')}
                </button>
            </div>
        </div>
    );
};

export { StayoverOverlapSelection };
